export default __webpack_public_path__ + "static/media/menu.30621943.svg";